import { useEffect } from "react";
import { Link } from "react-router-dom";
import { usePageHeader } from "@/layout/usePageHeader";

export function NotFoundPage() {
  const { setPageMeta } = usePageHeader();

  useEffect(() => {
    setPageMeta({ title: "Seite nicht gefunden" });
    return () => setPageMeta(null);
  }, [setPageMeta]);

  return (
    <div className="rounded-ios-lg border border-dashed border-separator bg-card p-8 text-center shadow-ios">
      <p className="text-sm text-label-secondary">Diese Seite existiert nicht.</p>
      <Link
        to="/"
        className="mt-5 inline-block rounded-full bg-accent px-4 py-2 text-sm font-medium text-label-on-accent shadow-sm transition hover:bg-accent-hover"
      >
        Zur Startseite
      </Link>
    </div>
  );
}
